<h2 mat-dialog-title>Alterar Categoria</h2>

<mat-dialog-content>
  <p class="hint-text">
    Selecione a nova categoria para {{ data.lancamentos.length }} lançamento(s) selecionado(s). Deixe em
    branco e salve para remover a categoria.
  </p>

  @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="categoria-section">
      <app-select-pesquisavel
        [control]="categoriaCtrl"
        label="Categoria"
        [offlineList]="categoriaOptions"
        [preloadedOptions]="categoriaOptions"
        idField="id"
        nameField="descricao"
        [isOptional]="true">
      </app-select-pesquisavel>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()" [disabled]="isLoading">Salvar</button>
</mat-dialog-actions>
